import { render } from "./DevicesSurvey.vue?vue&type=template&id=1242451a"
import script from "./DevicesSurvey.vue?vue&type=script&lang=js"
export * from "./DevicesSurvey.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/pescle-rodent/pescle-rodent/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__